import Request from './request'

const Device = {
  getDeviceProfile (fid, callback, bad_answer) {
    Request.get('device/view/' + fid).then(callback).catch(bad_answer)
  },
  getDeviceHistoryAction(id, callback) {
    Request.get('device/actions-log/' + id).then(callback).catch(this.bad_answer)
  },
  getDeviceSimcards (fid, callback) {
    Request.post('device/simcard-list/' + fid).then(callback).catch(this.bad_answer)
  },
  getClientInfoDevice (fid, callback) {
    Request.post('device/client-info/' + fid).then(callback).catch(this.bad_answer)
  },
  saveDeviceProfile (fid, params, callback) {
    Request.post('device/update/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  setDeviceBlockStatus (fid, params, callback) {
    Request.post('device/set-block-status/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceVersionHistory(id, callback) {
    Request.get('device/version-history/' + id).then(callback).catch(this.bad_answer)
  },
  getDeviceSimcardTraffic(fid, params, callback) {
    Request.post('device/simcard-traffic/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceChannelStatus(fid, callback) {
    Request.post('device/channel-status/' + fid).then(callback).catch(this.bad_answer)
  },
  getDeviceModelInfo(fid, callback){
    Request.post('device/model/' + fid).then(callback).catch(this.bad_answer)
  },
  updateDeviceSku(fid, params, callback) {
    Request.post('device/'+ fid + '/sku', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Device
